import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./open-sans.css";

// "@sentry/react": "^6.18.2",
// "@sentry/tracing": "^6.18.2",

// import * as Sentry from "@sentry/react";
// import { Integrations } from "@sentry/tracing";

// Sentry.init({
//   dsn: "https://26a6b0700433474a97c1c2fd0fa0ee22@o1076724.ingest.sentry.io/6078845",
//   integrations: [new Integrations.BrowserTracing()],

//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
// });

const rootElement = document.getElementById("root") as HTMLElement;
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// function isBrowseNotSupported() {
//   const EDGE_MIN_VERSION = "14";
//   const FIREFOX_MIN_VERSION = "52";
//   const CHROME_MIN_VERSION = "49";
//   const SAFARI_MIN_VERSION = "10";
//   return (
//     isIE ||
//     (isEdge && browserVersion < EDGE_MIN_VERSION) ||
//     (isFirefox && browserVersion < FIREFOX_MIN_VERSION) ||
//     (isChrome && browserVersion < CHROME_MIN_VERSION) ||
//     (isSafari && browserVersion < SAFARI_MIN_VERSION)
//   );
// }
